import classNames from 'classnames'
import { Col, Form, Row } from 'react-bootstrap'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Switch from 'antd/es/switch'

import InputLabel from 'components/ui/forms/field/input-label/InputLabel'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ISenceIntegrationForm } from 'models/integrations'
import { useField } from '../../../context'
import { prefix } from '../common'
import styles from './Sence.module.scss'
import SelectInput from 'components/ui/forms/field/select-input/SelectInput'

const optionsTrainingLine = [1, 2, 3].map((item) => ({
  value: `${item}`,
  label: item,
}))

interface IProps {
  disabled?: boolean
}

export const Sence = ({ disabled = false }: IProps) => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.integrations.sence`,
  })
  const integrations = useField('integrations')
  const { value, change } = integrations
  const valueSence = value?.sence

  const senceState = valueSence?.state

  const onChange = (values: ISenceIntegrationForm) => {
    change({ ...value, sence: values })
  }

  const trainingLineValue = optionsTrainingLine.find(
    (item) => item.value === valueSence?.trainingLine
  )
  return (
    <div className="mt-2">
      <Row className="align-items-center">
        <Col xs="auto">
          <InputLabel
            className="mb-0 align-items-center"
            label={
              <>
                {t('label')}
                <CommonToolTip text={t('tooltip')} position="right">
                  <FontAwesomeIcon icon={faInfoCircle} className={`ml-2`} />
                </CommonToolTip>
              </>
            }
          />
        </Col>
        <Col xs className="px-0 d-flex align-items-center">
          <Switch
            className={styles.switch}
            checkedChildren={t('switchTrue')}
            unCheckedChildren={t('switchFalse')}
            checked={!!senceState}
            onChange={(newValue) => {
              onChange({ ...valueSence, state: newValue })
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      {valueSence && (
        <div
          className={classNames(styles.senceForm, !senceState && styles.hidden)}
        >
          <InputLabel
            label={
              <>
                {t('senceCode.label')}
                <CommonToolTip text={t('senceCode.tooltip')} position="right">
                  <FontAwesomeIcon icon={faInfoCircle} className={`ml-2`} />
                </CommonToolTip>
              </>
            }
          />
          <Form.Control
            name={'senceCode'}
            value={valueSence?.code || ''}
            onChange={(e) => {
              onChange({ ...valueSence, code: e.target.value })
            }}
          />
          <div className="mt-2">
            <InputLabel
              label={
                <>
                  {t('senceCourseCode.label')}
                  <CommonToolTip
                    text={t('senceCourseCode.tooltip')}
                    position="right"
                  >
                    <FontAwesomeIcon icon={faInfoCircle} className={`ml-2`} />
                  </CommonToolTip>
                </>
              }
            />
            <Form.Control
              name={'courseCode'}
              value={valueSence?.courseCode || ''}
              onChange={(e) => {
                onChange({ ...valueSence, courseCode: e.target.value })
              }}
            />
          </div>
          <div className="mt-2">
            <InputLabel
              label={
                <>
                  {t('senceTrainingLine.label')}
                  <CommonToolTip
                    text={t('senceTrainingLine.tooltip')}
                    position="right"
                  >
                    <FontAwesomeIcon icon={faInfoCircle} className={`ml-2`} />
                  </CommonToolTip>
                </>
              }
            />
            <SelectInput
              name={'senceTrainingLine'}
              onChange={(e) => {
                onChange({
                  ...valueSence,
                  trainingLine: e?.value || '',
                })
              }}
              placeHolder={t('senceTrainingLine.placeHolder')}
              isMulti={false}
              isClearable
              options={optionsTrainingLine}
              value={trainingLineValue}
            />
          </div>
        </div>
      )}
    </div>
  )
}
